import { render, staticRenderFns } from "./KingdomPanel.vue?vue&type=template&id=c70ad00a&scoped=true"
import script from "./KingdomPanel.vue?vue&type=script&lang=js"
export * from "./KingdomPanel.vue?vue&type=script&lang=js"
import style0 from "./KingdomPanel.vue?vue&type=style&index=0&id=c70ad00a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70ad00a",
  null
  
)

export default component.exports